module.exports = __webpack_public_path__ + "789a600d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/routes/home/img/partners/image010.jpg
// module id = 727
// module chunks = 1